module.exports = __webpack_public_path__ + "static/media/cart.eb901ad9.svg";